/* @flow */
import AdminNewAutoMessageModal from './AdminNewAutoMessageModal';

export type AutoMessageTabKey = 'format-csv' | 'sync-data' | 'compose' | 'review';

export type AutoMessageTab = {
  tabKey: AutoMessageTabKey,
  name: string,
  component: React.Element<any>,
  nextStep: ?AutoMessageTabKey,
  prevStep: ?AutoMessageTabKey,
  isComplete: boolean,
};

export default AdminNewAutoMessageModal;
